import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Github = () => {
  return (
    <StartInterviewLayout type="github"/>
  )
}

export default Github;